import styled from 'styled-components';

export const Wrapper = styled.div`
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;
